<template>
	<v-app theme="light" style="background-color: #eeeeee">
		<nav-bar-portal />

		<VMain>
			<v-container>
				<v-row class="contentRow">
					<v-col>
						<h1>Not Found</h1>
						<p>We're sorry, but we could not find the page you were looking for.</p>
						<v-btn outlined color="secondary" to="/">Back To Home</v-btn>
					</v-col>
				</v-row>
			</v-container>
		</VMain>
		<test-error />
	</v-app>
</template>

<script>
export default {
	name: "NotFound",
}
</script>
